import { render, staticRenderFns } from "./ComponentDepsTool.vue?vue&type=template&id=af384794&scoped=true"
import script from "./ComponentDepsTool.vue?vue&type=script&lang=js"
export * from "./ComponentDepsTool.vue?vue&type=script&lang=js"
import style0 from "./ComponentDepsTool.vue?vue&type=style&index=0&id=af384794&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af384794",
  null
  
)

export default component.exports